import { get } from 'lodash';
import {
    RateFormator,
    currencyFormatorOfficial,
    formatDate, currencyFormatorWithDecimal,
} from 'utils/formator';
import { t } from 'i18next';

export const CreditReceiptList = ({ i18n, data, isClientSide }) => {
    console.log('data: ', data);
    return [
        ...(!get(data, 'mtTicket')
            ? []
            : [
                {
                    label: i18n('ticket'),
                    value: get(data, 'mtTicket'),
                },
            ]),
        ...(!get(data, 'ticket')
            ? []
            : [
                {
                    label: i18n('crmTicket'),
                    value: get(data, 'ticket'),
                },
            ]),
        {
            label: i18n('lastUpdateOn'),
            value: get(data, 'updatedAt')
                ? formatDate(get(data, 'updatedAt'))
                : get(data, 'createdAt') ? formatDate(get(data, 'createdAt')) : '',
        },
        {
            label: i18n('status'),
            value: t(get(data, 'status')),
        },
        {
            label: i18n('tradeType'),
            value: get(data, 'tradeType')
        },
        {
            label: i18n('transactionType'),
            value: i18n('credit'),
        },
        {
            label: t('toAccount'),
            value: get(data, 'toAccount'),
        },
        {
            label: t('toAmount'),
            value: get(data, 'toAmount'),
        },
        {
            label: i18n('comment'),
            value: get(data, 'comment'),
        },
        ...(get(data, 'failedReason') && get(data, 'status') === 'failed'
            ? [
                {
                    label: i18n('failedReason'),
                    value: get(data, 'failedReason'),
                },
            ]
            : []),
    ];
};